export type PathIndexed = {
  path_index: number;
  showSelectionColumn: boolean;
};

export const NAME_WIDTH = 200;
export const SELECT_WIDTH = 40;
export const POSITION_STICKY = 'sticky' as const;
export const POSITION_STATIC = 'static' as const;

/**
 * Name of the CSS custom property carrying a column's width.
 *
 * Column ids are not automatically safe to embed in a custom property name.
 * Custom field columns include the field id, which the API returns as
 * "CustomField:<uuid>" - and a ":" is illegal in a custom property name, so
 * `style.setProperty()` silently drops the declaration and the matching
 * `var()` resolves to nothing. The header then has no usable width, and
 * because `.lp-table` is `table-layout: fixed` the column collapses to 0px
 * while its header contents (filter box, clear icon) spill over the
 * neighbouring column. Sanitising here keeps writer and reader in step.
 */
export function columnSizeVar(prefix: 'header' | 'col', id: string): string {
  return `--${prefix}-${id.replace(/[^a-zA-Z0-9_-]/g, '_')}-size`;
}
